/**
 * Created by Zac on 13/04/2016.
 */

$(function () {

    // $('.gh-modal').on('shown.bs.modal', function () {
    //     console.log("modal opened");
    //     if ($(this).find(".modal-dialog > .modal-content > .modal-nav-tabs") != null) {
    //         $(this).find(".modal-dialog > .modal-content > .modal-nav-tabs a:first").click();
    //     }
    // });
});


// WEBPACK FOOTER //
// Glasshouse/Core/js/modal.js